/**
 * 전역 confirm 다이얼로그 API.
 *
 * native `confirm()`은 스타일 커스터마이즈 불가 + 브라우저마다 다름 → 제품 톤앤매너 유지 불가.
 * 본 모듈은 Vue ref 상태 + <ConfirmDialog> 컴포넌트 조합으로 교체.
 *
 * 사용:
 *   import { showConfirm } from '@/composables/confirm'
 *   if (await showConfirm({ message: 'foo?', title: 'Hi' })) { ... }
 */
import { ref } from 'vue'

export interface ConfirmOpts {
  title?: string
  message: string
  okText?: string
  cancelText?: string
  danger?: boolean
}

interface ConfirmState extends ConfirmOpts {
  resolve: (v: boolean) => void
}

export const confirmState = ref<ConfirmState | null>(null)

export function showConfirm(opts: ConfirmOpts): Promise<boolean> {
  return new Promise((resolve) => {
    // 이미 열린 다이얼로그가 있으면 이전 것 취소 처리
    if (confirmState.value) {
      confirmState.value.resolve(false)
    }
    confirmState.value = { ...opts, resolve }
  })
}

export function closeConfirm(result: boolean) {
  if (confirmState.value) {
    const r = confirmState.value.resolve
    confirmState.value = null
    r(result)
  }
}
